export const FORCE_VIDEO_STATUS = 'events/FORCE_VIDEO_STATUS';

/**
 * @return {{type: string}}
 */
export const forceVideoMediaStatus = (payload) => ({ type: FORCE_VIDEO_STATUS, payload });
